var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinearChartIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838F",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M3.5 19v-5M6.5 19v-7M9.5 19v-3M12.5 19v-6M15.5 19v-9M18.5 19V4M21.5 19V7"
})));
export default SvgLinearChartIcon;